<template>
  <div>
    <RadioButtonComponent
      :value="value"
      :label="label"
      :name="name"
      :checked="_checked"
      @change="change"
    />
  </div>
</template>

<script setup lang="ts">
import {ChangeArgs, RadioButtonComponent} from "@syncfusion/ej2-vue-buttons";
import {onMounted, ref} from "vue";

interface Props {
  label?: string,
  modelValue?: string,
  name?: string
  value?: string
}

const props = withDefaults(defineProps<Props>(), {
    label: undefined,
    modelValue: undefined,
    name: undefined,
    value: undefined
  }
)
const emit = defineEmits(['update:modelValue'])

const _checked = ref(false)

function change(args: ChangeArgs) {
//  console.log(args);
  emit('update:modelValue', args.value)
}

onMounted(() => {
  _checked.value = props.modelValue === props.value
})

</script>

<style scoped>

</style>
